import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { LoanAmountPickerRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { LoanAmountPickerResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const completeLoanAmountSelection = (request: LoanAmountPickerRequest, options?: CashRequestOptions) =>
  post<LoanAmountPickerRequest, LoanAmountPickerResponse>('/2.0/cash/complete-loan-amount-selection', request, {
    ...options,
    rejectOnError: true,
  })
